import copy from '~/components/atoms/a-copy/a-copy.data'

export default {
  ...copy,
  reverse: false,
  heading: 'Celebrating the rich hertiage of Volkswagen, with a modern twist.',
  copy: 'Taking inspiration from Volkswagen’s growing heritage fleet of over 13 carefully preserved vehicles, we took people on a journey through time to celebrate the brands continued commitment to design and quality – virtues that have come to define Volkswagen.',
  image: {
    alt: 'Entry image.',
    filename:
      '//a.storyblok.com/f/46530/1480x833/edbca44c51/01-hero-adidasrunning-001.png',
  },
  component: 'm-article-with-image',
}
